import { render, staticRenderFns } from "./TableOneToMany.vue?vue&type=template&id=69f8df20"
import script from "./TableOneToMany.vue?vue&type=script&lang=js"
export * from "./TableOneToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports